export default {
  SET_WEATHER_ENTRIES: (state, payload) => state.weatherEntries = payload
}